<hr />
<div class="text-center">
  <h1>- DENTBOX CHAT - </h1>
</div>
<hr />